import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { EntityBranchGroupHdrContainerModel } from '../../../../../models/aggregates/intercompany/index';

@Injectable({ providedIn: 'root' })
export class EntityBranchGroupHdrService extends BaseApiTemplateService<EntityBranchGroupHdrContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-branch-group-hdrs/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-branch-group-hdrs/backoffice-ep';
        this.httpClient = http;
    }
}
